import { PIXI } from '@colonist/pixi';
import { SectionBgView } from './SectionBgView.ts';
import { UICanvasConfig } from './UICanvasConfig.ts';
import { Sprites } from '../ui_game/UIGameImageDictionary.ts';
import { UIGameSpriteHandler } from '../UIGameSpriteHandler.ts';
import { GameColor } from '@colonist/ui-game';
export class SectionBgAdaptiveView extends PIXI.Container {
    get absoluteHeight() {
        const absoluteHeight = this.getLocalBounds().top + this.height;
        return absoluteHeight;
    }
    get absoluteWidth() {
        const absoluteWidth = this.getLocalBounds().left + this.width;
        return absoluteWidth;
    }
    addChild(...children) {
        for (const child of children){
            if (child instanceof PIXI.Text) this.textDimensions = {
                width: this.textDimensions.width + child.width,
                height: this.textDimensions.height + child.height
            };
        }
        return super.addChild(...children);
    }
    drawTextureBgAroundContent(horizontalBuffer = 0, verticalBuffer = 0, backgroundTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_section), radius = 5) {
        this.resetSectionBgView(horizontalBuffer, verticalBuffer);
        this.sectionBgView.drawRoundedBg(backgroundTexture, undefined, radius);
        this.sectionBgView.zIndex = -1;
        this.sortChildren();
    }
    drawBgAroundContent(horizontalBuffer = 0, verticalBuffer = 0, alpha = 1, radius = 5) {
        this.resetSectionBgView(horizontalBuffer, verticalBuffer);
        this.sectionBgView.drawBg(GameColor.getColorHexValue(GameColor.Color.PrimaryBlue6), alpha, 1, GameColor.getColorHexValue(GameColor.Color.White), 1, radius);
        this.sectionBgView.zIndex = -1;
        this.sortChildren();
    }
    resetSectionBgView(horizontalBuffer, verticalBuffer) {
        var _this_sectionBgView_parent, _this_sectionBgView;
        (_this_sectionBgView = this.sectionBgView) === null || _this_sectionBgView === void 0 ? void 0 : (_this_sectionBgView_parent = _this_sectionBgView.parent) === null || _this_sectionBgView_parent === void 0 ? void 0 : _this_sectionBgView_parent.removeChild(this.sectionBgView);
        const fullWidth = this.calculateFullWidth(horizontalBuffer);
        const fullHeight = this.calculateFullHeight(verticalBuffer);
        this.sectionBgView = new SectionBgView(0, 0, fullWidth, fullHeight, this);
    }
    calculateFullWidth(horizontalBuffer) {
        const textWidth = this.textDimensions.width;
        const spritesWidth = this.absoluteWidth + UICanvasConfig.margin + horizontalBuffer;
        return textWidth > spritesWidth ? textWidth : spritesWidth;
    }
    calculateFullHeight(verticalBuffer) {
        const textHeight = this.textDimensions.height;
        const spritesHeight = this.absoluteHeight + UICanvasConfig.margin + verticalBuffer;
        return textHeight > spritesHeight ? textHeight : spritesHeight;
    }
    constructor(...args){
        super(...args), this.textDimensions = {
            width: 0,
            height: 0
        };
    }
}
